import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

// const PRIMARY = {
//   lighter: '#f6f6fd',
//   light: '#e2dff5',
//   main: '#6368B4',
//   dark: '#061B64',
//   darker: '#011C27',
//   contrastText: '#fff',
// };

const PRIMARY = {
  lighter: '#F0F8FF',
  light: '#76B0F1',
  main: '#2065D1',
  dark: '#103996',
  darker: '#061B64',
  contrastText: '#fff',
};

const SECONDARY = {
  // lighter: '#FFFAF0',
  lighter: '#FAF0E6',
  light: '#ffc721',
  main: '#FF8200',
  dark: '#ff9b33',
  darker: '#ff9b33',
  contrastText: '#fff',
};

const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#1890FF',
  dark: '#0C53B7',
  darker: '#04297A',
  contrastText: '#fff',
};

const SUCCESS = {
  lighter: '#E9FCD4',
  light: '#AAF27F',
  main: '#54D62C',
  dark: '#229A16',
  darker: '#08660D',
  contrastText: GREY[800],
};

const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01',
  contrastText: GREY[800],
};

const ERROR = {
  lighter: '#FFE7D9',
  light: '#FFA48D',
  main: '#cc0000',
  // main: '#FF4842',
  dark: '#B72136',
  darker: '#7A0C2E',
  contrastText: '#fff',
};

const BRAND = {
  lighter: '#49678b',
  light: '#FFA48D',
  main: '#ff0000',
  dark: '#364c66',
  darker: '#364c66',
  contrastText: '#fff',
};

// KIMS cold-chain status tokens.
// Deliberate, contained deviation from theme success/warning/error: clinical
// monitoring needs unambiguous forest-green / amber / true-red. These are an
// EXTENSION (theme.palette.kims.*), never an override of success/warning/error.
// Single source of truth for the 5 statuses across cards, legend, table rows,
// map markers and charts — replaces the previously divergent KIMS_CARD_COLORS,
// STATUS_LEGEND, KIMS_STATUS_STYLES, KIMS_STANDARD_TONE and the pie-chart array.
export const KIMS_STATUS = {
  normal: {
    lighter: '#E9F7EA', light: '#7FC784', main: '#2E7D32', dark: '#1B5E20', contrastText: '#FFFFFF',
  },
  warning: {
    lighter: '#FFF3E0', light: '#FFB74D', main: '#ED6C02', dark: '#B85600', contrastText: '#FFFFFF',
  },
  critical: {
    lighter: '#FDEBEC', light: '#EF8A93', main: '#D32F2F', dark: '#A02020', contrastText: '#FFFFFF',
  },
  offline: {
    lighter: '#ECEFF1', light: '#B0BEC5', main: '#78909C', dark: '#546E7A', contrastText: '#FFFFFF',
  },
  battery: {
    lighter: '#F1F6E5', light: '#A9C77A', main: '#6B982B', dark: '#4E7220', contrastText: '#FFFFFF',
  },
  // Sensor reporting but its display temperature is silent (NA) — distinct from
  // a fully-offline logger and from a live excursion. Muted indigo so it reads
  // as "inconclusive / needs attention", never as a red breach.
  noData: {
    lighter: '#EFEDF5', light: '#B5AACF', main: '#7A6C9E', dark: '#584B77', contrastText: '#FFFFFF',
  },
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  brand: BRAND,
  // KIMS status tokens: grouped (theme.palette.kims.critical.main) and as
  // top-level palette colors so <Label color="kimsCritical" variant="soft" />
  // and sx={{ color: 'kimsWarning.main' }} resolve directly.
  kims: KIMS_STATUS,
  kimsNormal: KIMS_STATUS.normal,
  kimsWarning: KIMS_STATUS.warning,
  kimsCritical: KIMS_STATUS.critical,
  kimsOffline: KIMS_STATUS.offline,
  kimsBattery: KIMS_STATUS.battery,
  kimsNoData: KIMS_STATUS.noData,
  divider: alpha(GREY[500], 0.24),
  text: {
    primary: GREY[900],
    secondary: GREY[700],
    disabled: GREY[500],
  },
  background: {
    paper: GREY[0],
    default: GREY[100],
    // default: GREY[0],
    neutral: GREY[200],
  },
  action: {
    active: GREY[600],
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;
